import React, {useEffect} from "react"
import {Dispatch, SetStateAction} from "react";
import {Col, Modal, Row} from 'react-bootstrap'
import {fetchOneSms} from "../../api/SmsAPI";
import {useAppDispatch, useAppSelector} from "../../redux/Hooks";

interface Props {
    show: boolean,
    setShow: Dispatch<SetStateAction<boolean>>
    smsId?: number
}

export function SmsShow({show, setShow, smsId}: Props) {
    const dispatch = useAppDispatch()
    const token = sessionStorage.getItem('token_user_instance')
    const sms = useAppSelector((state) => state.sms.item)

    useEffect(() => {
        smsId && dispatch(fetchOneSms({token: token, id: smsId }))
    }, [smsId])

    return (
        <>
            <Modal show={show} scrollable onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title as="h3">Détails du vote</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="bg-white px-3 px-lg-5 py-2">
                        <div className="list-group list-group-flush">
                            <div className="list-group-item py-3 fw-semibold d-none d-lg-block">
                                <Row className="row-sm pb-3">
                                    <Col>Organisation syndicale</Col>
                                    <Col>Représentant</Col>
                                    <Col>Statut</Col>
                                    <Col className="text-center">Vote</Col>
                                </Row>
                            </div>
                        </div>

                        {sms && sms.smsUsers.map((item, index) => {
                            return <div className="list-group-item py-2" key={index} >
                                <div className="row row-sm row-sm-h">
                                    <Col xs={12} md={4} lg>
                                        <div className="label fs-sm d-lg-none">Organisation syndicale</div>
                                        {item.syndicate}
                                    </Col>
                                    <Col xs={12} md={4} lg className="text-primary">
                                        <div className="label fs-sm d-lg-none">Représentant</div>
                                        {item.user.niceName}
                                    </Col>
                                    <Col xs={12} md={4} lg>
                                        <div className="label fs-sm d-lg-none">Statut</div>
                                        {item.status}
                                    </Col>
                                    <Col xs={12} md={4} lg className="text-center">
                                        <div className="label fs-sm d-lg-none">Vote</div>
                                        {
                                            item.answer && 'Oui'
                                        }
                                        {
                                            item.answer !== undefined && !item.answer && 'Non'
                                        }
                                        {
                                            item.answer === undefined && '-'
                                        }
                                    </Col>
                                </div>
                            </div>
                        })}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
